export default __webpack_public_path__ + "static/media/close.4beb9432eda6c0251c0ab4342d282bc0.svg";